module.exports = __webpack_public_path__ + "img/zx3.1df807e8.png";